export default ctx => {
  const { auth, coaching } = ctx.store.state
  if (!auth.locked) return
  const { path } = ctx.route
  if (
    path === '/' ||
    path.startsWith('/offline') ||
    path.startsWith('/locked') ||
    (path.startsWith('/coaching') && coaching.current)
  )
    return
  ctx.redirect('/locked')
}
